let punteggioTotale = 0;
let vite = 5;

export const GAME_SCALE = 0.8;

export function setupSceneScale() {
    camScale(GAME_SCALE);
}

function viewWidth() {
    return width() / GAME_SCALE;
}

function viewHeight() {
    return height() / GAME_SCALE;
}

export function addBackground() {
    add([
        sprite("sfondo", {
            width: width(),
            height: height(),
        }),
        pos(0, 0),
        anchor("topleft"),
        layer("bg"),
        fixed(),
    ]);
}

export function resetPunteggio() {
    punteggioTotale = 0;
    vite = 5;
}

export function getPunteggio() {
    return punteggioTotale;
}

function formatPunteggio(n) {
    return String(n).padStart(2, "0");
}

export function addButton(txt, p, f) {
    const btnWidth = Math.min(480, width() * 0.75);
    const btn = add([
        rect(btnWidth, 64, { radius: 8 }),
        pos(p),
        area(),
        scale(1),
        anchor("center"),
        outline(4),
        color(255, 255, 255),
    ]);

    // add a child object that displays the text
    btn.add([
        text(txt),
        anchor("center"),
        color(0, 0, 0),
    ]);

    // onHoverUpdate() comes from area() component
    // it runs every frame when the object is being hovered
    btn.onHoverUpdate(() => {
        const t = time() * 10;
        btn.color = hsl2rgb((t / 10) % 1, 0.6, 0.7);
        btn.scale = vec2(1.2);
        setCursor("pointer");
    });

    // onHoverEnd() comes from area() component
    // it runs once when the object stopped being hovered
    btn.onHoverEnd(() => {
        btn.scale = vec2(1);
        btn.color = rgb();
    });

    // onClick() comes from area() component
    // it runs once when the object is clicked
    btn.onClick(f);

    return btn;
}

function setupPlayerMovement(k, player, speed) {
    let leftHeld = false;
    let rightHeld = false;
    let moveDir = 0;

    function updateMoveDir() {
        if (leftHeld && !rightHeld) {
            moveDir = -1;
        } else if (rightHeld && !leftHeld) {
            moveDir = 1;
        } else {
            moveDir = 0;
        }
    }

    function resetMovement() {
        leftHeld = false;
        rightHeld = false;
        moveDir = 0;
        if (player.exists()) {
            player.vel.x = 0;
        }
    }

    k.onKeyPress("left", () => {
        leftHeld = true;
        updateMoveDir();
    });

    k.onKeyPress("right", () => {
        rightHeld = true;
        updateMoveDir();
    });

    k.onKeyRelease("left", () => {
        leftHeld = false;
        updateMoveDir();
        if (player.exists()) {
            player.vel.x = 0;
        }
    });

    k.onKeyRelease("right", () => {
        rightHeld = false;
        updateMoveDir();
        if (player.exists()) {
            player.vel.x = 0;
        }
    });

    k.onHide(resetMovement);

    player.onDestroy(resetMovement);

    player.onUpdate(() => {
        if (moveDir === -1) {
            player.move(-speed, 0);
        } else if (moveDir === 1) {
            player.move(speed, 0);
        }
    });

    return { resetMovement };
}

export function generaLivello(k, LIVELLO, livelloSuccessivo) {
    k.setGravity(2000);
    setupSceneScale();
    const SPEED = 480;
    const ENEMY_SPEED = 120;
    const LEVEL_ORIGIN = vec2(100, 100);
    const levelCols = Math.max(...LIVELLO.map((row) => row.length));
    const levelWorldWidth = levelCols * 64;
    addBackground();

    function spin(speed = 1200) {
        let spinning = false;
        return {
            require: ["rotate"],
            update() {
                if (!spinning) {
                    return;
                }
                this.angle -= speed * dt();
                if (this.angle <= -360) {
                    spinning = false;
                    this.angle = 0;
                }
            },
            spin() {
                spinning = true;
            },
        };
    }

    function isMaialeOnHead(maiale, col) {
        if (col?.isTop()) {
            return true;
        }

        const pBox = player.worldArea().bbox();
        const mBox = maiale.worldArea().bbox();
        const playerTop = pBox.pos.y;
        const maialeBottom = mBox.pos.y + mBox.height;
        const overlapY = maialeBottom - playerTop;
        return overlapY > 0 && overlapY < mBox.height / 2 && maiale.vel.y > 0;
    }

    function canStompMaiale(maiale, col) {
        if (isMaialeOnHead(maiale, col)) {
            return false;
        }
        if (col?.isBottom()) {
            return true;
        }

        const pBox = player.worldArea().bbox();
        const mBox = maiale.worldArea().bbox();
        const playerBottom = pBox.pos.y + pBox.height;
        const maialeMidY = mBox.pos.y + mBox.height / 2;
        return playerBottom <= maialeMidY;
    }

    function stompMaiale(maiale) {
        if (!maiale.exists()) {
            return;
        }
        destroy(maiale);
        k.play("score");
        punteggioTotale += 10;
        punteggio.text = formatPunteggio(punteggioTotale);
        player.vel.y = -JUMP_FORCE * 0.4;
    }

    function maialeHurtPlayer(maiale, col) {
        player.hurt(1);
        if (isMaialeOnHead(maiale, col) && maiale.exists()) {
            destroy(maiale);
        }
    }

    function setupMaialeChase(maiale, player, speed = 300) {
        maiale.onUpdate(() => {
            const dx = player.worldPos().x - maiale.worldPos().x;
            if (Math.abs(dx) < 1) {
                maiale.vel.x = 0;
                return;
            }

            const direction = Math.sign(dx);
            maiale.vel.x = direction * speed;
            maiale.flipX = direction > 0;
        });
    }

    function setupBossChase(boss, player, speed, minX, maxX) {
        boss.onUpdate(() => {
            if (!boss.isGrounded()) {
                boss.vel.x = 0;
                return;
            }

            const bossX = boss.worldPos().x;
            if (bossX <= minX || bossX >= maxX) {
                boss.vel.x = 0;
                return;
            }

            const dx = player.worldPos().x - bossX;
            if (Math.abs(dx) < 1) {
                boss.vel.x = 0;
                return;
            }

            const direction = Math.sign(dx);
            const nextX = bossX + direction * speed * dt();
            if (nextX <= minX || nextX >= maxX) {
                boss.vel.x = 0;
                return;
            }

            boss.vel.x = direction * speed;
            boss.flipX = direction > 0;
        });
    }

    function spawnMaiale() {
        const margin = 64;
        const spawnX = rand(
            LEVEL_ORIGIN.x + margin,
            LEVEL_ORIGIN.x + levelWorldWidth - margin,
        );
        const spawnY = LEVEL_ORIGIN.y - 64;
        const maiale = add([
            sprite("maiale"),
            pos(spawnX, spawnY),
            anchor("bot"),
            area(),
            body(),
            color(),
            rotate(),
            offscreen({ destroy: true }),
            "maiale",
        ]);
        setupMaialeChase(maiale, player);
        return maiale;
    }

    const JUMP_FORCE = 700;
    const level = addLevel(LIVELLO, {
        tileWidth: 64,
        tileHeight: 64,
        pos: LEVEL_ORIGIN,
        tiles: {
            "@": () => [
                sprite("pando"),
                area(),
                body(),
                anchor("bot"),
                body({ jumpForce: JUMP_FORCE }),
                doubleJump(),
                rotate(0),
                spin(),
                health(vite),
                "player",
            ],
            "M": () => [
                sprite("maiale"),
                anchor("bot"),
                area(),
                body(),
                color(),
                rotate(),
                offscreen({ destroy: true }),
                "maiale",
            ],
            "B": () => [
                sprite("boss"),
                anchor("bot"),
                area(),
                body(),
                color(),
                rotate(),
                "boss",
            ],
            "=": () => [
                sprite("grass"),
                area(),
                body({ isStatic: true }),
                anchor("bot"),
            ],
            "$": () => [
                sprite("bamboo"),
                area({ isSensor: true }),
                anchor("bot"),
                "bamboo",
            ],
            "^": () => [
                sprite("bambooninja"),
                area({ isSensor: true }),
                anchor("bot"),
                "bambooninja",
            ],
            ">": () => [
                sprite("portal"),
                area({ isSensor: true }),
                anchor("bot"),
                "portal",
            ],
            "*": () => [
                sprite("ghosty"),
                area({ isSensor: true }),
                anchor("bot"),
                state("move", ["idle", "move"]),
                scale(1.5),
                "ghosty",
            ],
            "H": () => [
                rotate(0),
                "flamebar"
            ]
        },
    });

      
        

    function addFlamebar(flameHead) {
        let num = 7;
        for (let i = 0; i < num; i++) {
            flameHead.add([
                sprite("lightening"),
                pos(0, i * 48),
                area({ isSensor: true }),
                anchor("center"),
                "flame",
            ]);
        }

        // The flame head's rotation will affect all its children
        flameHead.onUpdate(() => {
            flameHead.angle += dt() * 60;
        });
    }

    if (level.get("flamebar").length > 0) {
        addFlamebar(level.get("flamebar")[0]);
    }

    // Get the player object from tag
    const player = level.get("player")[0];
    player.onDoubleJump(() => {
        // So we can call the spin() method provided by the spin() component to spin
        player.spin();
    });

    onKeyPress("n", () => {
        if (livelloSuccessivo == null) livelloSuccessivo = 'vittoria';
        go(livelloSuccessivo);
    });

    onKeyPress("up", () => {
        player.doubleJump();
    });

    const { resetMovement } = setupPlayerMovement(k, player, SPEED);

    const levelBottomY = LEVEL_ORIGIN.y + LIVELLO.length * 64;
    const levelMinX = LEVEL_ORIGIN.x;
    const levelMaxX = LEVEL_ORIGIN.x + levelWorldWidth;
    const levelMinY = LEVEL_ORIGIN.y;
    const levelMaxY = levelBottomY;

    function clampCamera(center, min, max, viewSize) {
        if (max - min <= viewSize) {
            return (min + max) / 2;
        }
        return Math.max(min + viewSize / 2, Math.min(max - viewSize / 2, center));
    }

    player.onUpdate(() => {
        camPos(
            clampCamera(player.pos.x, levelMinX, levelMaxX, viewWidth()),
            clampCamera(player.pos.y, levelMinY, levelMaxY, viewHeight()),
        );

        if (player.pos.y >= levelBottomY + 32) {
            player.hurt(1);
        }
    });

    const punteggio = k.add([
            text(formatPunteggio(punteggioTotale)),
            pos(50, 20),
            fixed(),
        ])

    player.onCollide("bambooninja", () => {
        player.hurt(1);
    });

    player.onCollide('flame', () => {
        player.hurt(1);
    });

    player.onCollide("bamboo", (bamboo) => {
        destroy(bamboo);
        k.play("score");
        punteggioTotale += 1;
        punteggio.text = formatPunteggio(punteggioTotale);
    });

    player.onCollide("portal", () => {
        k.play("portal");
        k.go(livelloSuccessivo);
    });

    let cuori = [];
    for (let i = 0; i< vite;i++) {
        cuori.push(k.add([
            sprite("heart"),
            pos(100 + i * 15,20),
            fixed(),
            "cuore"+i 
        ]))
    }
    player.on("hurt", () => {
        k.play("pericolo");
        resetMovement();
        player.pos = level.tile2Pos(0, 0);
        vite = vite - 1;
       k.destroy(cuori[vite]);
    })
    player.on("death",() => {
        resetMovement();
        destroy(player);
        go("sconfitta");
    })

    for (const maiale of level.get("maiale")) {
        setupMaialeChase(maiale, player);
    }

    player.onCollide("maiale", (maiale, col) => {
        if (canStompMaiale(maiale, col)) {
            stompMaiale(maiale);
            return;
        }
        if (!col || col.isLeft() || col.isRight() || isMaialeOnHead(maiale, col)) {
            maialeHurtPlayer(maiale, col);
        }
    });

    player.onCollideUpdate("maiale", (maiale, col) => {
        if (canStompMaiale(maiale, col)) {
            stompMaiale(maiale);
        }
    });

    const boss = level.get("boss")[0];
    if (boss) {
        const BOSS_VITE_MAX = 3;
        let bossVite = BOSS_VITE_MAX;
        let bossVivo = true;
        let bossInvulnerabile = false;
        let bossRecupero = false;

        const bossMinX = LEVEL_ORIGIN.x + 32;
        const bossMaxX = LEVEL_ORIGIN.x + levelWorldWidth - 32;
        const bossMaxY = LEVEL_ORIGIN.y + LIVELLO.length * 64 + 48;

        setupBossChase(boss, player, 200, bossMinX, bossMaxX);

        const posizioniBoss = [];
        for (let row = 0; row < LIVELLO.length; row++) {
            const line = LIVELLO[row];
            for (let col = 0; col < line.length; col++) {
                if (line[col] === "=") {
                    posizioniBoss.push(level.tile2Pos(col, row));
                }
            }
        }

        const lowestPlatformY = Math.max(...posizioniBoss.map((p) => p.y));

        const bossCuori = [];
        for (let i = 0; i < BOSS_VITE_MAX; i++) {
            bossCuori.push(k.add([
                sprite("heart"),
                pos(width() - 80 - i * 18, 100),
                fixed(),
                color(255, 80, 80),
                "bossCuore",
            ]));
        }

        function spostaBossCasuale() {
            const posAttuale = boss.pos;
            const lontane = posizioniBoss.filter((p) => {
                return p.dist(player.pos) > 128 && p.dist(posAttuale) > 64;
            });
            const scelte = lontane.length > 0 ? lontane : posizioniBoss.filter(
                (p) => p.dist(posAttuale) > 64,
            );
            const dest = scelte.length > 0 ? choose(scelte) : choose(posizioniBoss);
            boss.pos = dest.clone();
            boss.vel.x = 0;
            boss.vel.y = 0;
        }

        function recuperaBossFuoriPerimetro() {
            if (!bossVivo || bossRecupero) {
                return;
            }
            bossRecupero = true;
            boss.vel.x = 0;
            boss.vel.y = 0;
            spostaBossCasuale();
            wait(0.5, () => {
                bossRecupero = false;
            });
        }

        boss.onUpdate(() => {
            if (!bossVivo) {
                return;
            }

            const fuoriX = boss.pos.x < bossMinX || boss.pos.x > bossMaxX;
            const caduto = boss.pos.y > bossMaxY
                || (!boss.isGrounded() && boss.vel.y > 0 && boss.pos.y > lowestPlatformY + 64);

            if (fuoriX || caduto) {
                recuperaBossFuoriPerimetro();
                return;
            }
        });

        function sconfiggiBoss() {
            bossVivo = false;
            for (const cuore of bossCuori) {
                if (cuore.exists()) {
                    destroy(cuore);
                }
            }
            destroy(boss);
            k.play("score");
            punteggioTotale += 100;
            punteggio.text = formatPunteggio(punteggioTotale);
            go("vittoria");
        }

        function colpisciBoss() {
            if (!bossVivo || bossInvulnerabile) {
                return;
            }

            bossInvulnerabile = true;
            bossVite -= 1;
            k.play("score");
            player.vel.y = -JUMP_FORCE * 0.4;
            boss.color = rgb(255, 80, 80);

            if (bossCuori[bossVite]?.exists()) {
                destroy(bossCuori[bossVite]);
            }

            if (bossVite <= 0) {
                sconfiggiBoss();
                return;
            }

            spostaBossCasuale();
            wait(0.25, () => {
                if (boss.exists()) {
                    boss.color = rgb();
                }
            });
            wait(0.6, () => {
                bossInvulnerabile = false;
            });
        }

        function provaColpoBoss(col) {
            if (!bossVivo || bossInvulnerabile) {
                return;
            }
            if (canStompMaiale(boss, col)) {
                colpisciBoss();
                return;
            }
            if (!col || col.isLeft() || col.isRight() || isMaialeOnHead(boss, col)) {
                player.hurt(1);
            }
        }

        player.onCollide("boss", (_b, col) => {
            provaColpoBoss(col);
        });

        player.onCollideUpdate("boss", (_b, col) => {
            if (canStompMaiale(boss, col)) {
                provaColpoBoss(col);
            }
        });

        (async () => {
            while (bossVivo) {
                await wait(3);
                if (!bossVivo) {
                    break;
                }
                spawnMaiale();
            }
        })();
    }

    const enemy = level.get("ghosty")[0];
    if (enemy != null) {    
        enemy.onStateEnter("idle", async () => {
            await wait(1);
            enemy.enterState("move");
        });
        enemy.onStateEnter("move", async () => {
            await wait(0.5);
            enemy.enterState("idle");
        });
        enemy.onStateUpdate("move", () => {
            // We move the enemy in the direction of the player
            const dir = player.pos.sub(enemy.pos).unit();
            enemy.move(dir.scale(ENEMY_SPEED));
        });
        player.onCollide("ghosty", () => {
            player.hurt(1);
        });
    }

    return level;
}